export default {
	chufadimudidi: '出发地/目的地',
	xiugaisouxun: '修改搜寻',
	you: '由',
	xianshi: '显示',
	jieguo: '结果',
	paixufangshi: '排序方式',
	zuipianyi: '最便宜',
	zuikuai: '最快',
	tuiguang: '推广',
	tingzhan: '停站',
	tingzhanyi: '停站',
	zhifei: '直飞(不停站)',
	yigetingzhan: '1个停站',
	duoguoliangge: '多过2个停站',
	meiyouchangshijian: '没有长时间停留',
	shaoyusixiaoshi: '少于4小时',
	jiagefanwei: '价格范围',
	hanshui: '含税',
	hangbanshikebiao: '航班时刻表',
	tingliushijian: '停留时间',
	tingliu: '停留',
	hangkonggongsi: '航空公司',
	lianmeng: '联盟',
	jiebo: '接驳',
	zongjia: '总价',
	xianzaiyuding: '现在预订',
	chakantanpai: '查看碳排放',
	shengyu: '剩余',
	gezuowei: '个座位',
	zongfeixingshijian: '总飞行时间',
	feixingshijian: '飞行时间',
	hangbanxiangxixinxi: '航班详细信息',
	xianshigengduo: '显示更多',
	quanxuan: '全选',
	qingchu: '清除',
	xuanzenindefukuanfangshi: '选择您的付款方式',
	xinyongkajiejika: '信用卡/借记卡',
	qingshurunindexiangxixinxi: '请输入您的信用卡/借记卡详细信息',
	xinyongkajiejikakahao: '信用卡/借记卡卡号',
	youxiaoriqi: '有效日期',
	kayanzhengma: '卡验证码',
	yanzhengmatishi: '卡验证码是位于信用卡背后，签名方格内号码的最后三个数字为 CVC2 (MasterCard)码。',
	dianziyoujian: '电子邮件地址（可选）',
	lijifukuan: '立即付款',
	quxiaobingfanhui: '取消并返回',
	wuxiaoka: '无效卡',
	yichang: "状态异常,请联系银行客服人员解决",
	jiagefashengbiandong: '价格发生变动，正在重新查询航班',
	ren: '乘客',
	chengkepingjunjiage: '每位乘客的平均价格',
};
